import { DmDataService } from './dm-data';
import { EmployeeDataService } from './employee-data/employee-data.service';
import { InventoryItemService } from './inventory-item';
import { ItemCountService } from './item-count/item-count.service';
import { RecipeVenueService } from './recipe-venue';
import { TransferDataService } from './transfer-data';
import { XeaDataService } from './xea-data';
import { XprtDataService } from './xprt-data';
import { XviDataService } from './xvi-data';

const DATA_SERVICES: any[] = [
  ItemCountService,
  DmDataService,
  XprtDataService,
  XviDataService,
  XeaDataService,
  InventoryItemService,
  RecipeVenueService,
  TransferDataService,
  EmployeeDataService,
];

export { DATA_SERVICES };
